import ImageItem from "./components/ImageItem";
import Spinner from "features/spinner/Spinner";
import { useGetMediaEntityQuery } from "app/api/media";
import { Box } from "@mui/material";

type SlideShowItemProps = { active?: boolean; verificationId: string };

const SlideShowItem: React.FC<SlideShowItemProps> = (props) => {
  const { active = true, verificationId } = props;
  const { data: media, isLoading } = useGetMediaEntityQuery(
    { fileId: verificationId },
    { skip: !active }
  );

  if (isLoading || !media)
    return (
      <Box
        sx={{
          display: "grid",
          placeItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Spinner size="3rem" color="#5f5f5f" />
      </Box>
    );

  if (!media) throw Error("Media not found");

  if (media.mediaType === "video/mp4") {
    return (
      <Box sx={{ position: "relative", ml: 2, top: "50%", transform: "translateY(-50%)" }}>
        <Box component="video" width="100%" controls>
          <Box component="source" src={media.imgUrl} type={media.mediaType} />
        </Box>
      </Box>
    );
  } else {
    return <ImageItem mediaUrl={media} />;
  }
};

export default SlideShowItem;
